module.exports = __webpack_public_path__ + "img/travancore-logo.97ee4638.png";